import React from 'react';
import S from './Styles';
import Loader from '../../components/loader';

// data-testid marks the route-level Suspense fallback so tests can detect the lazy-route hydration
// flash (SSR content → this loader → content) that appears when the route chunk isn't preloaded.
export const LoaderPage = () => (
  <div data-testid="route-loader">
    <LoaderContent />
  </div>
);

export const LoaderContent = () => (
  <S.Wrapper>
    <Loader />
  </S.Wrapper>
);
